import React from "react";
import TPCLearnerLogin from "../../TPC_Group_Manual_Register/TPCLearnerLogin";

export default function AIProfessionalApplicationLogin() {
  return (
    <TPCLearnerLogin
      applicationScope="ai-professional"
      loginTitle="AI Professional Application Login"
      welcomeText="AI Professional Application"
      learnerFlag={false}
      alternateLoginRoute="/trade-application-login"
      alternateLoginLabel="Trade application"
    />
  );
}
